module.exports = __webpack_public_path__ + "img/12.7773bc72.jpg";